import messagingEnum from './messaging';

export default {
	countries: [
		{
			string: gettext('Choose...'),
			value: 'placeholder',
		},
		{
			string: 'Canada',
			value: 'Canada',
		},
		{
			string: 'United States',
			value: 'United States',
		},
		{
			string: 'Afghanistan',
			value: 'Afghanistan',
		},
		{
			string: 'Aland Islands',
			value: 'Aland Islands',
		},
		{
			string: 'Albania',
			value: 'Albania',
		},
		{
			string: 'Algeria',
			value: 'Algeria',
		},
		{
			string: 'American Samoa',
			value: 'American Samoa',
		},
		{
			string: 'Andorra',
			value: 'Andorra',
		},
		{
			string: 'Angola',
			value: 'Angola',
		},
		{
			string: 'Anguilla',
			value: 'Anguilla',
		},
		{
			string: 'Antarctica',
			value: 'Antarctica',
		},
		{
			string: 'Antigua and Barbuda',
			value: 'Antigua and Barbuda',
		},
		{
			string: 'Argentina',
			value: 'Argentina',
		},
		{
			string: 'Armenia',
			value: 'Armenia',
		},
		{
			string: 'Aruba',
			value: 'Aruba',
		},
		{
			string: 'Australia',
			value: 'Australia',
		},
		{
			string: 'Austria',
			value: 'Austria',
		},
		{
			string: 'Azerbaijan',
			value: 'Azerbaijan',
		},
		{
			string: 'Bahamas',
			value: 'Bahamas',
		},
		{
			string: 'Bahrain',
			value: 'Bahrain',
		},
		{
			string: 'Bangladesh',
			value: 'Bangladesh',
		},
		{
			string: 'Barbados',
			value: 'Barbados',
		},
		{
			string: 'Belarus',
			value: 'Belarus',
		},
		{
			string: 'Belgium',
			value: 'Belgium',
		},
		{
			string: 'Belize',
			value: 'Belize',
		},
		{
			string: 'Benin',
			value: 'Benin',
		},
		{
			string: 'Bermuda',
			value: 'Bermuda',
		},
		{
			string: 'Bhutan',
			value: 'Bhutan',
		},
		{
			string: 'Bolivia',
			value: 'Bolivia',
		},
		{
			string: 'Bosnia and Herzegovina',
			value: 'Bosnia and Herzegovina',
		},
		{
			string: 'Botswana',
			value: 'Botswana',
		},
		{
			string: 'Bouvet Island',
			value: 'Bouvet Island',
		},
		{
			string: 'Brazil',
			value: 'Brazil',
		},
		{
			string: 'British Indian Ocean Territory',
			value: 'British Indian Ocean Territory',
		},
		{
			string: 'Brunei Darussalam',
			value: 'Brunei Darussalam',
		},
		{
			string: 'Bulgaria',
			value: 'Bulgaria',
		},
		{
			string: 'Burkina Faso',
			value: 'Burkina Faso',
		},
		{
			string: 'Burundi',
			value: 'Burundi',
		},
		{
			string: 'Cambodia',
			value: 'Cambodia',
		},
		{
			string: 'Cameroon',
			value: 'Cameroon',
		},
		{
			string: 'Cape Verde',
			value: 'Cape Verde',
		},
		{
			string: 'Cayman Islands',
			value: 'Cayman Islands',
		},
		{
			string: 'Central African Republic',
			value: 'Central African Republic',
		},
		{
			string: 'Chad',
			value: 'Chad',
		},
		{
			string: 'Chile',
			value: 'Chile',
		},
		{
			string: 'China',
			value: 'China',
		},
		{
			string: 'Christmas Island',
			value: 'Christmas Island',
		},
		{
			string: 'Cocos (Keeling) Islands',
			value: 'Cocos (Keeling) Islands',
		},
		{
			string: 'Colombia',
			value: 'Colombia',
		},
		{
			string: 'Comoros',
			value: 'Comoros',
		},
		{
			string: 'Congo',
			value: 'Congo',
		},
		{
			string: 'Congo, The Democratic Republic of The',
			value: 'Congo, The Democratic Republic of The',
		},
		{
			string: 'Cook Islands',
			value: 'Cook Islands',
		},
		{
			string: 'Costa Rica',
			value: 'Costa Rica',
		},
		{
			string: 'Cote D\'ivoire',
			value: 'Cote D\'ivoire',
		},
		{
			string: 'Croatia',
			value: 'Croatia',
		},
		{
			string: 'Cuba',
			value: 'Cuba',
		},
		{
			string: 'Cyprus',
			value: 'Cyprus',
		},
		{
			string: 'Czech Republic',
			value: 'Czech Republic',
		},
		{
			string: 'Denmark',
			value: 'Denmark',
		},
		{
			string: 'Djibouti',
			value: 'Djibouti',
		},
		{
			string: 'Dominica',
			value: 'Dominica',
		},
		{
			string: 'Dominican Republic',
			value: 'Dominican Republic',
		},
		{
			string: 'Ecuador',
			value: 'Ecuador',
		},
		{
			string: 'Egypt',
			value: 'Egypt',
		},
		{
			string: 'El Salvador',
			value: 'El Salvador',
		},
		{
			string: 'Equatorial Guinea',
			value: 'Equatorial Guinea',
		},
		{
			string: 'Eritrea',
			value: 'Eritrea',
		},
		{
			string: 'Estonia',
			value: 'Estonia',
		},
		{
			string: 'Ethiopia',
			value: 'Ethiopia',
		},
		{
			string: 'Falkland Islands (Malvinas)',
			value: 'Falkland Islands (Malvinas)',
		},
		{
			string: 'Faroe Islands',
			value: 'Faroe Islands',
		},
		{
			string: 'Fiji',
			value: 'Fiji',
		},
		{
			string: 'Finland',
			value: 'Finland',
		},
		{
			string: 'France',
			value: 'France',
		},
		{
			string: 'French Guiana',
			value: 'French Guiana',
		},
		{
			string: 'French Polynesia',
			value: 'French Polynesia',
		},
		{
			string: 'French Southern Territories',
			value: 'French Southern Territories',
		},
		{
			string: 'Gabon',
			value: 'Gabon',
		},
		{
			string: 'Gambia',
			value: 'Gambia',
		},
		{
			string: 'Georgia',
			value: 'Georgia',
		},
		{
			string: 'Germany',
			value: 'Germany',
		},
		{
			string: 'Ghana',
			value: 'Ghana',
		},
		{
			string: 'Gibraltar',
			value: 'Gibraltar',
		},
		{
			string: 'Greece',
			value: 'Greece',
		},
		{
			string: 'Greenland',
			value: 'Greenland',
		},
		{
			string: 'Grenada',
			value: 'Grenada',
		},
		{
			string: 'Guadeloupe',
			value: 'Guadeloupe',
		},
		{
			string: 'Guam',
			value: 'Guam',
		},
		{
			string: 'Guatemala',
			value: 'Guatemala',
		},
		{
			string: 'Guernsey',
			value: 'Guernsey',
		},
		{
			string: 'Guinea',
			value: 'Guinea',
		},
		{
			string: 'Guinea-bissau',
			value: 'Guinea-bissau',
		},
		{
			string: 'Guyana',
			value: 'Guyana',
		},
		{
			string: 'Haiti',
			value: 'Haiti',
		},
		{
			string: 'Heard Island and Mcdonald Islands',
			value: 'Heard Island and Mcdonald Islands',
		},
		{
			string: 'Holy See (Vatican City State)',
			value: 'Holy See (Vatican City State)',
		},
		{
			string: 'Honduras',
			value: 'Honduras',
		},
		{
			string: 'Hong Kong',
			value: 'Hong Kong',
		},
		{
			string: 'Hungary',
			value: 'Hungary',
		},
		{
			string: 'Iceland',
			value: 'Iceland',
		},
		{
			string: 'India',
			value: 'India',
		},
		{
			string: 'Indonesia',
			value: 'Indonesia',
		},
		{
			string: 'Iran, Islamic Republic of',
			value: 'Iran, Islamic Republic of',
		},
		{
			string: 'Iraq',
			value: 'Iraq',
		},
		{
			string: 'Ireland',
			value: 'Ireland',
		},
		{
			string: 'Isle of Man',
			value: 'Isle of Man',
		},
		{
			string: 'Israel',
			value: 'Israel',
		},
		{
			string: 'Italy',
			value: 'Italy',
		},
		{
			string: 'Jamaica',
			value: 'Jamaica',
		},
		{
			string: 'Japan',
			value: 'Japan',
		},
		{
			string: 'Jersey',
			value: 'Jersey',
		},
		{
			string: 'Jordan',
			value: 'Jordan',
		},
		{
			string: 'Kazakhstan',
			value: 'Kazakhstan',
		},
		{
			string: 'Kenya',
			value: 'Kenya',
		},
		{
			string: 'Kiribati',
			value: 'Kiribati',
		},
		{
			string: 'Korea, Democratic People\'s Republic of',
			value: 'Korea, Democratic People\'s Republic of',
		},
		{
			string: 'Korea, Republic of',
			value: 'Korea, Republic of',
		},
		{
			string: 'Kuwait',
			value: 'Kuwait',
		},
		{
			string: 'Kyrgyzstan',
			value: 'Kyrgyzstan',
		},
		{
			string: 'Lao People\'s Democratic Republic',
			value: 'Lao People\'s Democratic Republic',
		},
		{
			string: 'Latvia',
			value: 'Latvia',
		},
		{
			string: 'Lebanon',
			value: 'Lebanon',
		},
		{
			string: 'Lesotho',
			value: 'Lesotho',
		},
		{
			string: 'Liberia',
			value: 'Liberia',
		},
		{
			string: 'Libyan Arab Jamahiriya',
			value: 'Libyan Arab Jamahiriya',
		},
		{
			string: 'Liechtenstein',
			value: 'Liechtenstein',
		},
		{
			string: 'Lithuania',
			value: 'Lithuania',
		},
		{
			string: 'Luxembourg',
			value: 'Luxembourg',
		},
		{
			string: 'Macao',
			value: 'Macao',
		},
		{
			string: 'Macedonia, The Former Yugoslav Republic of',
			value: 'Macedonia, The Former Yugoslav Republic of',
		},
		{
			string: 'Madagascar',
			value: 'Madagascar',
		},
		{
			string: 'Malawi',
			value: 'Malawi',
		},
		{
			string: 'Malaysia',
			value: 'Malaysia',
		},
		{
			string: 'Maldives',
			value: 'Maldives',
		},
		{
			string: 'Mali',
			value: 'Mali',
		},
		{
			string: 'Malta',
			value: 'Malta',
		},
		{
			string: 'Marshall Islands',
			value: 'Marshall Islands',
		},
		{
			string: 'Martinique',
			value: 'Martinique',
		},
		{
			string: 'Mauritania',
			value: 'Mauritania',
		},
		{
			string: 'Mauritius',
			value: 'Mauritius',
		},
		{
			string: 'Mayotte',
			value: 'Mayotte',
		},
		{
			string: 'Mexico',
			value: 'Mexico',
		},
		{
			string: 'Micronesia, Federated States of',
			value: 'Micronesia, Federated States of',
		},
		{
			string: 'Moldova, Republic of',
			value: 'Moldova, Republic of',
		},
		{
			string: 'Monaco',
			value: 'Monaco',
		},
		{
			string: 'Mongolia',
			value: 'Mongolia',
		},
		{
			string: 'Montenegro',
			value: 'Montenegro',
		},
		{
			string: 'Montserrat',
			value: 'Montserrat',
		},
		{
			string: 'Morocco',
			value: 'Morocco',
		},
		{
			string: 'Mozambique',
			value: 'Mozambique',
		},
		{
			string: 'Myanmar',
			value: 'Myanmar',
		},
		{
			string: 'Namibia',
			value: 'Namibia',
		},
		{
			string: 'Nauru',
			value: 'Nauru',
		},
		{
			string: 'Nepal',
			value: 'Nepal',
		},
		{
			string: 'Netherlands',
			value: 'Netherlands',
		},
		{
			string: 'Netherlands Antilles',
			value: 'Netherlands Antilles',
		},
		{
			string: 'New Caledonia',
			value: 'New Caledonia',
		},
		{
			string: 'New Zealand',
			value: 'New Zealand',
		},
		{
			string: 'Nicaragua',
			value: 'Nicaragua',
		},
		{
			string: 'Niger',
			value: 'Niger',
		},
		{
			string: 'Nigeria',
			value: 'Nigeria',
		},
		{
			string: 'Niue',
			value: 'Niue',
		},
		{
			string: 'Norfolk Island',
			value: 'Norfolk Island',
		},
		{
			string: 'Northern Mariana Islands',
			value: 'Northern Mariana Islands',
		},
		{
			string: 'Norway',
			value: 'Norway',
		},
		{
			string: 'Oman',
			value: 'Oman',
		},
		{
			string: 'Pakistan',
			value: 'Pakistan',
		},
		{
			string: 'Palau',
			value: 'Palau',
		},
		{
			string: 'Palestinian Territory, Occupied',
			value: 'Palestinian Territory, Occupied',
		},
		{
			string: 'Panama',
			value: 'Panama',
		},
		{
			string: 'Papua New Guinea',
			value: 'Papua New Guinea',
		},
		{
			string: 'Paraguay',
			value: 'Paraguay',
		},
		{
			string: 'Peru',
			value: 'Peru',
		},
		{
			string: 'Philippines',
			value: 'Philippines',
		},
		{
			string: 'Pitcairn',
			value: 'Pitcairn',
		},
		{
			string: 'Poland',
			value: 'Poland',
		},
		{
			string: 'Portugal',
			value: 'Portugal',
		},
		{
			string: 'Puerto Rico',
			value: 'Puerto Rico',
		},
		{
			string: 'Qatar',
			value: 'Qatar',
		},
		{
			string: 'Reunion',
			value: 'Reunion',
		},
		{
			string: 'Romania',
			value: 'Romania',
		},
		{
			string: 'Russian Federation',
			value: 'Russian Federation',
		},
		{
			string: 'Rwanda',
			value: 'Rwanda',
		},
		{
			string: 'Saint Helena',
			value: 'Saint Helena',
		},
		{
			string: 'Saint Kitts and Nevis',
			value: 'Saint Kitts and Nevis',
		},
		{
			string: 'Saint Lucia',
			value: 'Saint Lucia',
		},
		{
			string: 'Saint Pierre and Miquelon',
			value: 'Saint Pierre and Miquelon',
		},
		{
			string: 'Saint Vincent and The Grenadines',
			value: 'Saint Vincent and The Grenadines',
		},
		{
			string: 'Samoa',
			value: 'Samoa',
		},
		{
			string: 'San Marino',
			value: 'San Marino',
		},
		{
			string: 'Sao Tome and Principe',
			value: 'Sao Tome and Principe',
		},
		{
			string: 'Saudi Arabia',
			value: 'Saudi Arabia',
		},
		{
			string: 'Senegal',
			value: 'Senegal',
		},
		{
			string: 'Serbia',
			value: 'Serbia',
		},
		{
			string: 'Seychelles',
			value: 'Seychelles',
		},
		{
			string: 'Sierra Leone',
			value: 'Sierra Leone',
		},
		{
			string: 'Singapore',
			value: 'Singapore',
		},
		{
			string: 'Slovakia',
			value: 'Slovakia',
		},
		{
			string: 'Slovenia',
			value: 'Slovenia',
		},
		{
			string: 'Solomon Islands',
			value: 'Solomon Islands',
		},
		{
			string: 'Somalia',
			value: 'Somalia',
		},
		{
			string: 'South Africa',
			value: 'South Africa',
		},
		{
			string: 'South Georgia and The South Sandwich Islands',
			value: 'South Georgia and The South Sandwich Islands',
		},
		{
			string: 'Spain',
			value: 'Spain',
		},
		{
			string: 'Sri Lanka',
			value: 'Sri Lanka',
		},
		{
			string: 'Sudan',
			value: 'Sudan',
		},
		{
			string: 'Suriname',
			value: 'Suriname',
		},
		{
			string: 'Svalbard and Jan Mayen',
			value: 'Svalbard and Jan Mayen',
		},
		{
			string: 'Swaziland',
			value: 'Swaziland',
		},
		{
			string: 'Sweden',
			value: 'Sweden',
		},
		{
			string: 'Switzerland',
			value: 'Switzerland',
		},
		{
			string: 'Syrian Arab Republic',
			value: 'Syrian Arab Republic',
		},
		{
			string: 'Taiwan, Province of China',
			value: 'Taiwan, Province of China',
		},
		{
			string: 'Tajikistan',
			value: 'Tajikistan',
		},
		{
			string: 'Tanzania, United Republic of',
			value: 'Tanzania, United Republic of',
		},
		{
			string: 'Thailand',
			value: 'Thailand',
		},
		{
			string: 'Timor-leste',
			value: 'Timor-leste',
		},
		{
			string: 'Togo',
			value: 'Togo',
		},
		{
			string: 'Tokelau',
			value: 'Tokelau',
		},
		{
			string: 'Tonga',
			value: 'Tonga',
		},
		{
			string: 'Trinidad and Tobago',
			value: 'Trinidad and Tobago',
		},
		{
			string: 'Tunisia',
			value: 'Tunisia',
		},
		{
			string: 'Turkey',
			value: 'Turkey',
		},
		{
			string: 'Turkmenistan',
			value: 'Turkmenistan',
		},
		{
			string: 'Turks and Caicos Islands',
			value: 'Turks and Caicos Islands',
		},
		{
			string: 'Tuvalu',
			value: 'Tuvalu',
		},
		{
			string: 'Uganda',
			value: 'Uganda',
		},
		{
			string: 'Ukraine',
			value: 'Ukraine',
		},
		{
			string: 'United Arab Emirates',
			value: 'United Arab Emirates',
		},
		{
			string: 'United Kingdom',
			value: 'United Kingdom',
		},
		{
			string: 'United States Minor Outlying Islands',
			value: 'United States Minor Outlying Islands',
		},
		{
			string: 'Uruguay',
			value: 'Uruguay',
		},
		{
			string: 'Uzbekistan',
			value: 'Uzbekistan',
		},
		{
			string: 'Vanuatu',
			value: 'Vanuatu',
		},
		{
			string: 'Venezuela',
			value: 'Venezuela',
		},
		{
			string: 'Viet Nam',
			value: 'Viet Nam',
		},
		{
			string: 'Virgin Islands, British',
			value: 'Virgin Islands, British',
		},
		{
			string: 'Virgin Islands, U.S.',
			value: 'Virgin Islands, U.S.',
		},
		{
			string: 'Wallis and Futuna',
			value: 'Wallis and Futuna',
		},
		{
			string: 'Western Sahara',
			value: 'Western Sahara',
		},
		{
			string: 'Yemen',
			value: 'Yemen',
		},
		{
			string: 'Zambia',
			value: 'Zambia',
		},
		{
			string: 'Zimbabwe',
			value: 'Zimbabwe',
		},
	],
	loggedOutHelpOptions: [
		{
			string: gettext('Choose...'),
			phoneSupport: false,
			disableCategories:true,
			value: 'placeholder',
			zendeskValue: null,
		},
		{
			string: gettext('I’m not sure how to do something'),
			phoneSupport: false,
			value: 'howTo',
			zendeskValue: 'how-to',
			disableCategories: false,
		},
		{
			string: gettext('I’m getting an error'),
			phoneSupport: false,
			value: 'error',
			zendeskValue: 'system_issue',
		},
		{
			string: gettext('Something isn’t working as expected'),
			phoneSupport: false,
			value: 'unexpected',
			zendeskValue: 'configuration_issue',
		},
		{
			string: gettext('Someone else is having trouble'),
			phoneSupport: false,
			disableCategories: true,
			value: 'someoneElse',
			zendeskValue: 'local_issue',
			message: messagingEnum.someoneElseMessage,
		},
	],
	nonAdminHelpOptions: [
		{
			string: gettext('Choose...'),
			phoneSupport: false,
			disableCategories:true,
			value: 'placeholder',
			zendeskValue: null,
		},
		{
			string: gettext('I can’t find something'),
			phoneSupport: false,
			disableCategories:true,
			value: 'cantFind',
			zendeskValue: 'how-to',
			message: messagingEnum.ContactAdmin,
		},
		{
			string: gettext('I’m not sure how to do something'),
			phoneSupport: false,
			value: 'howTo',
			zendeskValue: 'how-to',
			disableCategories:false,
		},
		{
			string: gettext('I’m getting an error'),
			phoneSupport: true,
			value: 'error',
			zendeskValue: 'system_issue',
		},
		{
			string: gettext('I need help updating something'),
			phoneSupport: false,
			disableCategories:true,
			value: 'updating',
			zendeskValue: 'how-to',
			message: messagingEnum.ContactAdmin,
		},
		{
			string: gettext('Something isn’t working as expected'),
			phoneSupport: true,
			value: 'unexpected',
			zendeskValue: 'configuration_issue',
		},
		{
			string: gettext('Someone else is having trouble'),
			phoneSupport: true,
			disableCategories: true,
			value: 'someoneElse',
			zendeskValue: 'local_issue',
			message: messagingEnum.someoneElseMessage,
		},
		{
			string: gettext('I have general questions about the platform'),
			phoneSupport: true,
			value: 'general',
			zendeskValue: 'how-to',
		},
	],
	adminHelpOptions: [
		{
			string: gettext('Choose...'),
			phoneSupport: false,
			disableCategories:true,
			value: 'placeholder',
			zendeskValue: null,
		},
		{
			string: gettext('I can’t find something'),
			phoneSupport: true,
			value: 'cantFind',
			zendeskValue: 'how-to',
		},
		{
			string: gettext('A feature or functionality is missing'),
			phoneSupport: true,
			value: 'featureMissing',
			zendeskValue: 'configuration_issue',
		},
		{
			string: gettext('I’m not sure how to do something'),
			phoneSupport: false,
			value: 'howTo',
			zendeskValue: 'how-to',
			message: messagingEnum.howToMessage,
		},
		{
			string: gettext('I’m getting an error'),
			phoneSupport: true,
			value: 'error',
			zendeskValue: 'system_issue',
		},
		{
			string: gettext('I need help updating something'),
			phoneSupport: true,
			value: 'updating',
			zendeskValue: 'how-to',
		},
		{
			string: gettext('I need help creating something new'),
			phoneSupport: false,
			disableCategories: true,
			value: 'new',
			category: {
				label: 'I need help creating something new',
				articleTag: 'build',
				formLink: true,
				adminCanRequestCall: false,
			},
			zendeskValue: 'configuration_issue',
			message: messagingEnum.howToMessage,
		},
		{
			string: gettext('Something isn’t working as expected'),
			phoneSupport: true,
			value: 'unexpected',
			zendeskValue: 'configuration_issue',
		},
		{
			string: gettext('Someone else is having trouble'),
			phoneSupport: true,
			disableCategories: true,
			value: 'someoneElse',
			zendeskValue: 'local_issue',
			message: messagingEnum.someoneElseMessage,
		},
		{
			string: gettext('I have general questions about the platform'),
			phoneSupport: true,
			value: 'general',
			zendeskValue: 'how-to',
		},
	],
	categories: [
		{
			label: gettext('Accounts'),
			id: 'b1510d6e-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('User Account Changes'),
					id: 'b150ffb8-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_changes',
					roles: [
						'loggedIn',
					],
					articleTag: 'accounts_changes',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating/importing users'),
					id: 'b1510468-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'users_creating/importing',
					roles: [
						'admin',
					],
					articleTag: 'accounts_creating',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Custom Fields'),
					id: 'b15105e4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'users_custom_fields',
					roles: [
						'admin',
					],
					articleTag: 'accounts_metadata',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Deleting users'),
					id: 'b1510724-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'users_deleting',
					roles: [
						'admin',
					],
					articleTag: 'accounts_deleting',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Filtering users'),
					id: 'b1510850-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'users_filtering',
					roles: [
						'admin',
					],
					articleTag: 'accounts_filtering',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('GDPR'),
					id: 'b1510972-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_gdpr',
					roles: [
						'all',
					],
					articleTag: 'accounts_gdpr',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('I was locked out of my account'),
					id: 'b1510c24-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_login_issues',
					roles: [
						'loggedOut',
					],
					articleTag: null,
					formLink: false,
					message: messagingEnum.lockoutMessage,
					adminCanRequestCall: false,
				},
				{
					label: gettext('I\'m having trouble signing in'),
					id: 'b1510e9a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: null,
					roles: [
						'loggedOut',
					],
					articleTag: 'accounts_signingin',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: false,
				},
				{
					label: gettext('I\'m having trouble registering'),
					id: 'b1510fbc-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_registration',
					roles: [
						'loggedOut',
					],
					articleTag: 'accounts_registration',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: false,
				},
				{
					label: gettext('Organizations'),
					hideInFR: true,
					id: 'b15110f2-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_organizations',
					roles: [
						'all',
					],
					articleTag: 'accounts_orgs',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Login/registration issues for another user'),
					id: 'b1511520-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account__improper_login_request',
					roles: [
						'all',
					],
					articleTag: null,
					formLink: false,
					message: messagingEnum.regOtherMessage,
					adminCanRequestCall: false,
				},
				{
					label: gettext('Social media logins'),
					id: 'b151164c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account__login_issues__social_media',
					roles: [
						'all',
					],
					articleTag: 'accounts_social',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('User Profiles'),
					id: 'b1511778-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'users_user_profiles',
					roles: [
						'admin',
					],
					articleTag: 'accounts_profiles',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Verification'),
					id: 'b15118a4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account_verification',
					roles: [
						'all',
					],
					articleTag: 'accounts_verification',
					formLink: true,
					legacyValue: 'how_to',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b15119d0-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'account__login_issues__reason_unknown',
					roles: [
						'all',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Applications'),
			id: 'b1511c82-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Archive, withdraw or reactivate applications'),
					id: 'b1511de0-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications_managing_application_states',
					roles: [
						'admin',
					],
					articleTag: 'apps_archiving',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Award or decline decisions'),
					id: 'b1511f0c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: null,
					roles: [
						'admin',
					],
					articleTag: 'apps_decisions',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Collaborators'),
					id: 'b1512038-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications__managing__collaborators',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'apps_collaborators',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating or deleting applications'),
					id: 'b1512164-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications__managing__create/delete',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'apps_creating',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Downloading'),
					id: 'b1512286-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications_downloading',
					roles: [
						'loggedIn',
					],
					articleTag: 'apps_downloading',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Editing applications'),
					id: 'b151256a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications__managing__editing_applications',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'apps_editing',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Filtering'),
					id: 'b15126b4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications_filtering',
					roles: [
						'admin',
						'reviewers',
					],
					articleTag: 'apps_filtering',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Labels and custom statuses'),
					id: 'b15127e0-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications_managing_labels_and_custom_statuses',
					roles: [
						'admin',
					],
					articleTag: 'apps_labels',
					frLrticleTag: 'apps_labels',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Moving between stages'),
					id: 'b1512902-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications__managing__moving_stages',
					roles: [
						'admin',
					],
					articleTag: 'apps_stages',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Submitting or reopening applications'),
					id: 'b1512a2e-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications__managing__submit/reopen',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'apps_submit',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Custom fields'),
					id: 'b1512d8a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'applications_managing_custom_fields',
					roles: [
						'admin',
					],
					articleTag: 'apps_metadata',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b1512ee8-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'loggedIn',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: null,
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Automations'),
			id: 'b151301e-a7cb-11e9-a2a3-2a2ae2dbcce4',
			requiresProPackage: true,
			children: [
				{
					label: gettext('\'Do\' actions'),
					id: 'b151314a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'automations_actions',
					roles: [
						'admin',
					],
					articleTag: 'auto_do',
					formLink: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Activations (When to apply)'),
					id: 'b1513276-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'automations_activations',
					roles: [
						'admin',
					],
					articleTag: 'auto_activation',
					formLink: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Conditions'),
					id: 'b1513398-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'automations_conditions',
					roles: [
						'admin',
					],
					articleTag: 'auto_conditions',
					formLink: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating or managing automations'),
					id: 'b1513690-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'automations_creating/managing',
					roles: [
						'admin',
					],
					articleTag: 'auto_manage',
					formLink: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Limits, priority and delays'),
					id: 'b15137e4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'automations_behaviour',
					roles: [
						'admin',
					],
					articleTag: 'auto_behavior',
					formLink: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b1513910-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: '',
					formLink: true,
					sortLast: true,
					legacyValue: 'automation',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: true,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Downtime'),
			id: 'b1513a3c-a7cb-11e9-a2a3-2a2ae2dbcce4',
			zendeskValue: 'downtime',
			roles: [
				'all',
			],
			articleTag: 'downtime',
			formLink: true,
			legacyValue: 'other',
			relatedPrograms: null,
			relatedStages: null,
			relatedTasks: null,
			relatedUsers: null,
			relatedApplications: null,
			relatedReports: null,
			relatedAutomations: null,
			adminCanRequestCall: true,
		},
		{
			label: gettext('Emails'),
			id: 'b1513b68-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('An email wasn\'t received'),
					id: 'b1513c8a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'emails_email_not_received',
					roles: [
						'all',
					],
					articleTag: 'emails_not_received',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Attachments'),
					id: 'b1513ece-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'emails__composing__attachments',
					roles: [
						'all',
					],
					articleTag: 'emails_attachments',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Can\'t send an email'),
					id: 'b1513ffa-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'emails_can_t_send',
					roles: [
						'admin',
					],
					articleTag: 'emails_sending',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Composing an email'),
					id: 'b1514126-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: 'emails_composing',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Piping'),
					id: 'b1514252-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'emails__composing__piping',
					roles: [
						'admin',
					],
					articleTag: 'emails_piping',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b15144d2-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Feature Suggestions'),
			id: 'b1514612-a7cb-11e9-a2a3-2a2ae2dbcce4',
			zendeskValue: 'feature_suggestion',
			roles: [
				'admin',
			],
			articleTag: null,
			formLink: false,
			message: messagingEnum.featureSuggestionsMessage,
			adminCanRequestCall: false,
		},
		{
			label: gettext('Financial Management'),
			id: 'b151473e-a7cb-11e9-a2a3-2a2ae2dbcce4',
			requiresProPackage: true,
			children: [
				{
					label: gettext('Awarding or declining applications'),
					id: 'b1514860-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings__financial_management__awarding/declining_applications',
					roles: [
						'admin',
					],
					articleTag: 'financial_decision',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating funds'),
					id: 'b1514982-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings__financial_management__creating_funds',
					roles: [
						'admin',
					],
					articleTag: 'financial_funds',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Managing program budgets'),
					hideInFR: true,
					id: 'b1514aa4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings__financial_management__managing_program_budgets',
					roles: [
						'admin',
					],
					articleTag: 'financial_budgets',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b1514dc4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: '',
					formLink: true,
					sortLast: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Form Builder'),
			id: 'b1514f0e-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Form calculations'),
					id: 'b1515044-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'forms_aep',
					roles: [
						'admin',
					],
					articleTag: 'forms_aep',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Branching logic'),
					id: 'b1515170-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'forms_branching',
					roles: [
						'admin',
					],
					articleTag: 'forms_branching',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Form settings'),
					id: 'b151536e-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'forms_form/question_settings',
					roles: [
						'admin',
					],
					articleTag: 'forms_settings',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Piping variables'),
					id: 'b15154ae-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'forms_piping',
					roles: [
						'admin',
					],
					articleTag: 'forms_piping',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Updating questions on a form'),
					id: 'b15156ca-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'forms_adding/modifying_questions',
					roles: [
						'admin',
					],
					articleTag: 'forms_modifying',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b1515814-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: {
						required: true,
					},
					relatedUsers: null,
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Integrations'),
			id: 'b1515940-a7cb-11e9-a2a3-2a2ae2dbcce4',
			requiresProPackage: true,
			children: [
				{
					label: gettext('API'),
					id: 'b1515a6c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'integrations_api',
					roles: [
						'admin',
					],
					articleTag: 'integration_api',
					formLink: true,
					legacyValue: 'integration',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Guidestar'),
					hideInFR: true,
					id: 'b1515c92-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'integrations_guidestar',
					roles: [
						'admin',
					],
					articleTag: 'integration_guidestar',
					formLink: true,
					legacyValue: 'integration',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('Salesforce'),
					id: 'b1515dd2-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'integrations_salesforce',
					roles: [
						'admin',
					],
					articleTag: 'integration_salesforce',
					formLink: true,
					legacyValue: 'integration',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('UIS'),
					id: 'b1515efe-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'integrations__sis',
					roles: [
						'admin',
					],
					articleTag: 'integration_sis',
					formLink: true,
					legacyValue: 'integration',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: true,
				},
				{
					label: gettext('SSO'),
					id: 'b151602a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'integrations_sso',
					roles: [
						'admin',
					],
					articleTag: 'integration_sso',
					formLink: true,
					legacyValue: 'integration',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: true,
				},
			],
		},
		{
			label: gettext('Programs'),
			id: 'b1516296-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Adding or removing programs'),
					id: 'b15163cc-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'programs_add/remove',
					roles: [
						'admin',
					],
					articleTag: 'programs_managing',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Charity verification'),
					id: 'b15164f8-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks__charity',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'charity',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating or deleting tasks'),
					id: 'b1516624-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks_create/delete_tasks',
					roles: [
						'admin',
					],
					articleTag: 'tasks_managing',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Creating or deleting stages'),
					id: 'b1516746-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'stages_creating/delete_stages',
					roles: [
						'admin',
					],
					articleTag: 'stages_managing',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Deadlines'),
					id: 'b1516a16-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'programs_deadline',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'programs_deadline',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Eligibility'),
					id: 'b1516b56-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'programs_eligibility',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'programs_eligibility',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Payments'),
					id: 'b1516c82-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks_payments',
					roles: [
						'admin',
						'applicants',
					],
					articleTag: 'tasks_payment',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Program settings'),
					id: 'b1516dae-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'programs_program_settings',
					roles: [
						'admin',
					],
					articleTag: 'programs_settings',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Reusable applicant tasks'),
					id: 'b1516eda-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks_reusable_applicant_tasks',
					roles: [
						'admin',
					],
					requiresProPackage: true,
					articleTag: 'tasks_rats',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Stage settings'),
					id: 'b1517006-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'stages_stage_settings',
					roles: [
						'admin',
					],
					articleTag: 'stages_settings',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: true,
					},
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Task limits/restrictions'),
					id: 'b15172c2-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks__task_settings__limits/restrictions',
					roles: [
						'loggedIn',
					],
					articleTag: 'tasks_restrictions',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Task prerequisites'),
					id: 'b151740c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks__task_settings__prerequisites',
					roles: [
						'loggedIn',
					],
					articleTag: 'tasks_prerequisites',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Task settings'),
					id: 'b15175ec-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: 'tasks_settings',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Task upload conversion/preview'),
					id: 'b151774a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks_uploads',
					roles: [
						'loggedIn',
					],
					articleTag: 'tasks_preview',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Task upload error'),
					id: 'b1517876-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'tasks__uploads__errors_in_uploading',
					roles: [
						'loggedIn',
					],
					articleTag: 'tasks_upload',
					formLink: true,
					legacyValue: 'task_form',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b1517a24-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: {
						required: false,
					},
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Report Builder'),
			id: 'b1517b6e-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Building a report'),
					id: 'b1517e0c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting_managing_reports',
					roles: [
						'admin',
					],
					articleTag: 'reports_building',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Data inconsistency'),
					id: 'b1517f56-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting_data_inconsistency',
					roles: [
						'admin',
					],
					articleTag: 'reports_data',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: {
						required: true,
					},
					relatedStages: null,
					relatedTasks: {
						required: true,
					},
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: true,
					},
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Downloading reports'),
					id: 'b1518078-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting_downloading_reports',
					roles: [
						'admin',
					],
					articleTag: 'reports_downloading',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Filtering results'),
					id: 'b15181a4-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting_filtering',
					roles: [
						'admin',
					],
					articleTag: 'reports_filters',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Formulas'),
					hideInFR: true,
					id: 'b15185a0-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting_formulas',
					roles: [
						'admin',
					],
					articleTag: 'reports_formula',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Managing reports'),
					id: 'b1518712-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reporting__deleting/duplicating_reports',
					roles: [
						'admin',
					],
					articleTag: 'reports_managing',
					formLink: true,
					legacyValue: 'reporting',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: {
						required: true,
					},
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b151883e-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'reporting',
					relatedPrograms: {
						required: false,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: {
						required: true,
					},
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Reviews'),
			id: 'b1518b04-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Automatic assignments'),
					id: 'b1518c3a-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reviews_assignments_automatic',
					roles: [
						'admin',
					],
					articleTag: 'reviews_assignments',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: true,
					},
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Manual assignments'),
					id: 'b1518d5c-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reviews_assignments_manual',
					roles: [
						'admin',
					],
					articleTag: 'reviews_assignments',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: true,
					},
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Review teams'),
					id: 'b1518e92-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reviews_teams',
					roles: [
						'admin',
					],
					articleTag: 'reviews_teams',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: null,
					relatedStages: {
						required: false,
					},
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Reviewer dashboard'),
					id: 'b1518fbe-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'review__reviewing',
					roles: [
						'admin',
						'reviewers',
					],
					articleTag: 'reviews_dashboard',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: true,
					},
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Reviewing applications'),
					id: 'b15190e0-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'reviews__reviewing__side_by_side',
					roles: [
						'admin',
						'reviewers',
					],
					articleTag: 'reviews_reviewing',
					formLink: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: true,
					},
					relatedTasks: null,
					relatedUsers: {
						required: true,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('The issue I\'m experiencing isn\'t listed'),
					id: 'b151937e-a7cb-11e9-a2a3-2a2ae2dbcce4',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: true,
					sortLast: true,
					legacyValue: 'app_rev',
					relatedPrograms: {
						required: true,
					},
					relatedStages: {
						required: false,
					},
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: {
						required: false,
					},
					relatedAutomations: {
						required: false,
					},
					adminCanRequestCall: false,
				},
			],
		},
		{
			label: gettext('Site Settings'),
			id: 'b15194be-a7cb-11e9-a2a3-2a2ae2dbcce4',
			children: [
				{
					label: gettext('Activity'),
					id: 'b15195ea-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_activity',
					roles: [
						'admin',
					],
					articleTag: 'site_settings',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Administrators & permissions'),
					id: 'b1519716-a7cb-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_administrators___permissions',
					roles: [
						'admin',
					],
					articleTag: 'site_permissions',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: true,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('CSS & themes'),
					id: 'e70192fa-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings__css___themes',
					roles: [
						'admin',
					],
					articleTag: null,
					formLink: false,
					message: messagingEnum.cssMessage,
					adminCanRequestCall: false,
				},
				{
					label: gettext('Custom fields'),
					id: 'e701985e-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_custom_fields',
					roles: [
						'admin',
					],
					articleTag: 'site_metadata',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Domain & security'),
					id: 'e70199da-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_site_security',
					roles: [
						'admin',
					],
					articleTag: 'site_security',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Eligibility'),
					id: 'e7019b24-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_eligibility',
					roles: [
						'admin',
					],
					articleTag: 'site_eligibility',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Emails and notifications'),
					id: 'e7019c6e-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_emails_and_notifications',
					roles: [
						'admin',
					],
					articleTag: 'site_emails',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: {
						required: false,
					},
					relatedApplications: {
						required: false,
					},
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Package and features'),
					id: 'e7019da4-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_package_and_features',
					roles: [
						'admin',
					],
					articleTag: 'site_package',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Pages or files'),
					id: 'e701a006-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_resources',
					roles: [
						'admin',
					],
					articleTag: 'site_resources',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Registration'),
					id: 'e701a16e-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_registration',
					roles: [
						'admin',
					],
					articleTag: 'site_registration',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: {
						required: false,
					},
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Set up/Renew SSL certificate'),
					id: 'e701a5ba-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_site_security',
					roles: [
						'admin',
					],
					articleTag: 'site_ssl',
					formLink: true,
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					sslFields: true,
					adminCanRequestCall: false,
				},
				{
					label: gettext('Time and timezones'),
					id: 'e701a70e-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_time___timezones',
					roles: [
						'admin',
					],
					articleTag: 'site_time',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: null,
					relatedStages: null,
					relatedTasks: null,
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
				{
					label: gettext('Translations'),
					id: 'e701a83a-a8c3-11e9-a2a3-2a2ae2dbcce4',
					zendeskValue: 'site_settings_translations',
					roles: [
						'admin',
					],
					requiresProPackage: true,
					articleTag: 'site_translations',
					formLink: true,
					legacyValue: 'other',
					relatedPrograms: {
						required: false,
					},
					relatedStages: null,
					relatedTasks: {
						required: false,
					},
					relatedUsers: null,
					relatedApplications: null,
					relatedReports: null,
					relatedAutomations: null,
					adminCanRequestCall: true,
				},
			],
		},
	],
};
